module.exports = __webpack_public_path__ + "img/es.fb93ccf4.png";